import { isEditable } from '../../utils/piction';
import {
  AUDIO_FILE_TYPES,
  DOCUMENT_FILE_TYPES,
  IMAGE_FILE_TYPES,
  VIDEO_FILE_TYPES,
} from './constants';

export const trimFileName = (name, TRIM_LENGTH) => {
  if (name.length <= TRIM_LENGTH + 5) {
    return name;
  } else {
    const firstPart = name.slice(0, TRIM_LENGTH);
    const lastPart = name.slice(-5);
    return `${firstPart}...${lastPart}`;
  }
};

export const formatBytes = (bytes) => {
  const kilobyte = 1024;
  const megabyte = kilobyte * 1024;
  const gigabyte = megabyte * 1024;

  if (bytes < kilobyte) {
    return bytes + ' Bytes';
  } else if (bytes < megabyte) {
    return (bytes / kilobyte).toFixed(2) + ' KB';
  } else if (bytes < gigabyte) {
    return (bytes / megabyte).toFixed(2) + ' MB';
  } else {
    return (bytes / gigabyte).toFixed(2) + ' GB';
  }
};

export function delay(seconds) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(`Promise resolved after ${seconds} seconds`);
    }, seconds * 1000);
  });
}

function countNoOfCatOccurrences(array) {
  const counts = {};
  array.forEach((item) => {
    counts[item] = (counts[item] || 0) + 1;
  });
  return counts;
}

/**
 * Checks if the search parameters are valid for file uploader.
 *
 * @param {Object} searchParams - The search parameters object.
 * @param {Array} [searchParams.tagList] - List of search tags.
 * @param {Object} selectedCategory - The selected category object.
 * @returns {boolean} True if exactly one category is present in the search and matches the selected category.
 */
export const isValidForFileUploader = (searchParams, selectedCategory) => {
  if (!selectedCategory || !searchParams) {
    return false;
  }
  const IN_CATEGORY = 'IN_CATEGORY';
  let tagList = searchParams.tagList || [];
  let categoriesOnSearch = [];
  let categoryName = '';
  let categoryID = '';
  for (const tag of tagList) {
    if (tag.searchTerm && tag.searchTerm.keyword == IN_CATEGORY) {
      categoriesOnSearch.push(tag.searchTerm.value);
      categoryName = tag.label;
      categoryID = tag.searchTerm.value;
    }
  }
  let categoriesCount = countNoOfCatOccurrences(categoriesOnSearch);
  let noOfCategories = Object.keys(categoriesCount).length;
  return (
    noOfCategories === 1 &&
    categoryID === selectedCategory.get('i') &&
    isEditable(selectedCategory)
  );
};

export function getFileExtension(filename, isDotIncluded = true) {
  // Check if filename is valid
  if (typeof filename !== 'string' || filename.trim() === '') {
    return null;
  }

  const parts = filename.split('.');
  if (parts.length > 1) {
    return isDotIncluded
      ? '.' + parts[parts.length - 1]
      : parts[parts.length - 1];
  } else {
    return null;
  }
}

export const getThumbnail = (image) => {
  if (AUDIO_FILE_TYPES.includes(image.file.type))
    return './images/thumb/audio.jpg';
  else if (VIDEO_FILE_TYPES.includes(image.file.type))
    return './images/thumb/video.jpg';
  else if (IMAGE_FILE_TYPES.includes(image.file.type)) return image['data_url'];
  else if (DOCUMENT_FILE_TYPES.includes(image.file.type))
    return './images/thumb/document.jpg';
  else return './images/thumb/img_nothumb.gif';
};

export const isThumbnailAvailable = (image) => {
  if (
    AUDIO_FILE_TYPES.includes(image.file.type) ||
    VIDEO_FILE_TYPES.includes(image.file.type) ||
    IMAGE_FILE_TYPES.includes(image.file.type) ||
    DOCUMENT_FILE_TYPES.includes(image.file.type)
  )
    return true;
  else return false;
};
